'use strict';

var _ = require('lodash');
var PanelStateManager = function PanelStateManager() {
  function getInstance(panelsNames, initiallyVisiblePanelsNames) {
    function setInitialVisibilityState() {
      function isInitiallyVisible(panel) {
        return _.find(initiallyVisible, function (visiblePanel) {
          return visiblePanel === panel.name;
        });
      }
      panels.forEach(function (panel) {
        panel.visible = !!isInitiallyVisible(panel);
      });
    }
    var panels = [];
    var initiallyVisible = initiallyVisiblePanelsNames;
    panelsNames.forEach(function (panelName) {
      panels.push({
        name: panelName,
        visible: false,
        collapsed: true,
        hidden: false
      });
    });
    setInitialVisibilityState();
    return {
      setInitialVisibilityState: setInitialVisibilityState,
      collapseAll: function collapseAll() {
        panels.forEach(function (panel) {
          panel.collapsed = true;
          panel.hidden = false;
        });
      },
      getPanel: function getPanel(panelName) {
        return _.find(panels, {
          name: panelName
        });
      },
      setVisible: function setVisible(panelName, visible) {
        this.getPanel(panelName).visible = visible;
      },
      isVisible: function isVisible(panelName) {
        return this.getPanel(panelName).visible;
      },
      setCollapsed: function setCollapsed(panelName, collapsed) {
        this.getPanel(panelName).collapsed = collapsed;
      },
      isCollapsed: function isCollapsed(panelName) {
        return this.getPanel(panelName).collapsed;
      },
      togglePanelVisibility: function togglePanelVisibility(panelName) {
        var panel = this.getPanel(panelName);
        panel.visible = !panel.visible;
      },
      setHidden: function setHidden(panelName, hidden) {
        this.getPanel(panelName).hidden = hidden;
      },
      isHidden: function isHidden(panelName) {
        return this.getPanel(panelName).hidden;
      },
      togglePanelHidden: function togglePanelHidden(panelName) {
        var panel = this.getPanel(panelName);
        panel.hidden = !panel.hidden;
      }
    };
  }
  return {
    getInstance: getInstance
  };
};
PanelStateManager.$inject = [];
module.exports = PanelStateManager;